import { useMemo } from "react";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isSameMonth,
  isSameDay,
  format,
  parseISO,
} from "date-fns";
import "./CustomMiniCalendar.css";

const CustomMiniCalendar = ({ startDate, endDate, totalDays }) => {
  const start = parseISO(startDate);
  const end = parseISO(endDate);

  const hasHalfDay = totalDays % 1 !== 0;

  // Generate all selected dates
  const selectedDates = useMemo(() => {
    const days = [];
    let current = start;

    while (current <= end) {
      days.push(current);
      current = addDays(current, 1);
    }

    return days;
  }, [start, end]);

  const monthStart = startOfMonth(start);
  const monthEnd = endOfMonth(start);
  const calendarStart = startOfWeek(monthStart);
  const calendarEnd = endOfWeek(monthEnd);

  const rows = [];
  let day = calendarStart;

  while (day <= calendarEnd) {
    const days = [];

    for (let i = 0; i < 7; i++) {
      const cloneDay = day;

      const isSelected = selectedDates.some((d) => isSameDay(d, cloneDay));

      const isLastDay =
        hasHalfDay &&
        isSameDay(cloneDay, selectedDates[selectedDates.length - 1]);

      days.push(
        <div
          key={cloneDay}
          className={`cm-cell 
            ${!isSameMonth(cloneDay, monthStart) ? "disabled" : ""}
            ${isSelected ? "selected" : ""}
            ${isLastDay ? "half-day" : ""}
          `}
        >
          {format(cloneDay, "d")}
        </div>,
      );

      day = addDays(day, 1);
    }

    rows.push(
      <div className="cm-row" key={day}>
        {days}
      </div>,
    );
  }

  return (
    <div className="cm-mini-calendar">
      <div className="cm-header">{format(start, "MMM yyyy")}</div>
      <div className="cm-body">{rows}</div>
    </div>
  );
};

export default CustomMiniCalendar;
